import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"item-text":"title","color":"primary","label":_vm.$t('Cart Lock State'),"items":_vm.lockActions,"loading":_vm.loading,"disabled":_vm.loading,"outlined":"","dense":"","hide-details":"auto"},model:{value:(_vm.lockState),callback:function ($$v) {_vm.lockState=$$v},expression:"lockState"}})}
var staticRenderFns = []

export { render, staticRenderFns }